import { createFeatureSelector, createSelector } from "@ngrx/store";
import { Dictionary } from "@ngrx/entity";
import {userModelEntityAdapter, UsersState} from "./users.state";
import {UserModel} from "./user.model";

export const selectUsersState
    = createFeatureSelector<UsersState>("users");

export const { selectIds, selectEntities, selectAll, selectTotal } =
    userModelEntityAdapter.getSelectors(selectUsersState);

export const selectUserById = (id: string) =>
    createSelector(
        selectEntities,  // { [id]: User }
        entities => entities[id] ?? null
    );


export const selectUsersByIds = (ids: string[]) =>
    createSelector(
        selectAll,  // { [id]: User }
        entities => entities.filter(e => ids.includes(e.id)).slice()
    );

export const selectSubscribedToUserIds = createSelector(
    selectUsersState,
    (state: UsersState) => state.subscribedToUserIds
);